import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import OperationListEditor from './OperationListEditor';
import {postData, sendRequest} from "../../../utils/request";
import React, {Fragment} from "react";
import isEqual from "lodash-es/isEqual";
import ShopSupplementForm from "./Elements/ShopSupplementForm";
import {ProductColumn, UnitFormatter} from "../../../utils/formatters";
import TextInput from "../../form/TextInput";
import {ifCompletedInput} from "../../../utils/other";
import Button from "../../form/Button";
import {dateData} from "../../form/DateTimeInput";
import CheckBox from "../../form/CheckBox";
import {PriceView} from "../../classes/Price";
import {Tooltip} from "react-tippy";

const sortable = true;
const filterable = true;

class ShopSupplementEditor extends React.Component {

    state = {
        filtered: false,
        storefilter: false,
        componentEditor: "ShopSupplement",
        filter: [
            {column: "preset", value: "ShopSupplement"},
            {column: "saved", value: 1}
        ],
        actionButtons: [],
        availableShippingProviders: [],
        actions: true,
        pool: {
            pageSize: 50,
            pageSizes: [5,10,15,20,50,100],
            sortBy: {field: "displayname", direction: "ASC"},
            orderBy: {field: "outgoing", direction: "DESC"},
            selection: [],
            aggregations: {
                fields: {
                    "count": {
                        field: "pickedqty", type: "COUNT"
                    },
                    "pickedqty": {
                        field: "pickedqty", type: "SUM"
                    },
                }
            },
            parameters: {
                period: {
                    from: dateData(new Date()).value,
                    to: dateData(new Date()).value
                }
            },
            view: ["id","product_id","OperationList_id", "outgoing", "sold", "instore", "base_instore", "inwarehouse", "vat", "component_type", "component_id", ...PriceView("saleprice"), "saleprice", ...PriceView("listprice"), "listprice"],
            component: "ShopSupplementItem",
            className: "p-small-table ShopSupplement items",
            columns: {
                "displayname": {
                    ...ProductColumn("component_id"),
                    width: 1,
                },
                "category.name": {header: 'Árutípus', width: 1, sortable, filterable},
                "tradename.name": {header: 'Kiadó', width: 1, sortable, filterable},
                "outgoing": {header: 'Eladás', width: 1, sortable, filterable, renderer: (value, row) => UnitFormatter(value, row.unit)},
                "instore": {header: 'Készlet', className: "unit strict_reserved", width: 1, sortable, filterable, renderer: (value, row) => UnitFormatter(value, row.unit)},
                "base_instore": {header: 'Összesen', className: "unit text-left reserved", width: 1, sortable, filterable, renderer: (value, row) => UnitFormatter(value, row.unit)},
                "inwarehouse": {header: 'Raktár', width: 1, sortable, filterable, renderer: (value, row) => UnitFormatter(value, row.unit)},
                "intransitqty": {header: 'Szállítás alatt', width: 1, sortable, filterable, renderer: (value, row) => UnitFormatter(value, row.unit)},
                "pickedqty": {
                    header: "Rendelés",
                    width: 1,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    sortable,
                    filterable,
                    aggregation: (value, row) => {
                        return <Fragment><span className="unit">Összesen: {UnitFormatter(row.pickedqty || 0, row.unit).props.children}</span><span className="unit">Tétel: {UnitFormatter(row.count || 0, row.unit).props.children}</span></Fragment>;
                    },
                    className: "unit",
                    editor:
                        (parent) =>
                            (props, value) => {
                                return <TextInput type="number" name="pickedqty" label={false} focus value={value}
                                           onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>}
                },
            }
        }
    };

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    componentDidMount() {
        this.loadProviders();
    }

    getProps = () => {
        const props = {
            ...this.props,
            ...this.state,
        };
        props.actionButtons = [
            <Button key="4" type="button" disabled={ props.isLoading || !props.values.id } color="primary" className="pull-right" onClick={ async (e) => {
                const values = props.values;
                values.autocheckup = true;
                await props.processAction(async () => {
                    const response = await postData({
                        action: 'OperationList.doAction',
                        actionname: 'create',
                        data: await referenceActionData(values, this.props.componentConfig)
                    });
                    await this.props.pristineForm(false);
                    return response;
                });
            }}>
                Pótlás
            </Button>
        ];
        props.pool.parameters = {
            instore: 2,
        };
        if (props.values && props.values.id) {
            props.pool.parameters.OperationList_id = props.values.id;
        }
        if (props.period && props.period.from && props.period.to) {
            props.pool.parameters.period = {};
            if (props.period.from) {
                props.pool.parameters.period.from = props.period.from;
            }
            if (props.period.to) {
                props.pool.parameters.period.to = props.period.to;
            }
        } else {
            props.period = props.pool.parameters.period = {from: dateData(new Date()).value, to: dateData(new Date()).value};
        }
        props.pool = {...props.pool, columns: {...props.pool.columns}};
        if (props.values.target) {
            props.pool.parameters.store = props.values.target.id;
            props.pool.columns.instore.header = props.values.target.name + "/kiadás";
            props.pool.columns.base_instore.header = props.values.target.name + "/cím";
        }
        if (props.values.source) {
            props.pool.parameters.warehouse = props.values.source.id;
            props.pool.columns.inwarehouse.header = props.values.source.name;
        } else {
            delete props.pool.columns["inwarehouse"];
        }
        props.filtered = this.state.filtered;
        if (this.state.filtered) {
            props.pool.filter = [{field: "pickedqty", operator: "not isnull"}];
        } else {
            props.pool.filter = [];
        }
        props.storefilter = this.state.storefilter;
        if (this.state.storefilter) {
            props.pool.parameters.instore = 999999;
        }
        props.pool.paginatorRight = (props) => <Fragment>
            <Tooltip title={!this.state.filtered ? "Csak a kiválasztottakat mutasd" : "Mindent mutat"}>
                <CheckBox
                    onIcon={{lib: "fa", name: "box"}}
                    offIcon={{lib: "fa", name: "box-open"}}
                    value={this.state.filtered}
                    label={false}
                    saveChanges={(field, value) => {
                        this.setState({filtered: !!value});
                    }}
                    {...props}
                />
            </Tooltip>
            <Tooltip title={!this.state.storefilter ? "Teljes szortimentet mutasd" : "Fogyás szerinti pótlást mutasd"}>
                <CheckBox
                    onIcon={{lib: "fas", name: "th"}}
                    offIcon={{lib: "fas", name: "th-large"}}
                    value={this.state.storefilter}
                    label={false}
                    saveChanges={(field, value) => {
                        this.setState({storefilter: !!value});
                    }}
                    {...props}
                />
            </Tooltip>
        </Fragment>;
        return props;
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(prevProps.values, this.props.values)) {
            this.loadProviders();
        }
    }

    loadProviders = () => {
        if ((this.props.values.pos || {}).id) {
            this.availableShippings && this.availableShippings.abort();
            this.availableShippings = sendRequest({
                option: "componentlist",
                component: "ShippingServiceProvider",
                filter: [
                    {field: "pos", value: (this.props.values.pos || {}).id}
                ]
            });
            this.availableShippings.then((response) => {
                this.setState({
                    availableShippingProviders: response.items
                });
            });
        } else {
            this.setState({
                availableShippingProviders: [],
            });
        }
    }

    renderer = (componentProps) => {
        const onSourceItemUpdate = async (item, oldItem, field) => {
            if (!item.saleprice) {
                item.saleprice = item.listprice;
            }
            const res = await componentProps.parent.onSourceItemUpdate(item, oldItem, field);
            res.saleprice = item.listprice;
            return res;
        }
        return <ShopSupplementForm {...componentProps} setState={(state, cb) => this.setState(state, cb)} onSourceItemUpdate={onSourceItemUpdate} />;
    }

    render() {
        const Form = this.renderer;
        return <OperationListEditor {...this.getProps()}>
            <Form />
        </OperationListEditor>;
    }

}

export default createBackendEditor({
    componentName: "OperationList",
    WrappedComponent: ShopSupplementEditor,
    editor: "ShopSupplement",
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            params.preset = "ShopSupplement";
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
});